/* =====================================================================
   TPW FORM SWAP — async in-place form submit (P6 of the loading system)
   ---------------------------------------------------------------------
   Opt in by placing a wrapper [data-tpw-formswap="swap"|"morph"] INSIDE a
   Shopify {% form %}, containing:
     • [data-tpw-formhide]  — the fields/body to collapse on success
     • [data-tpw-formdone]  — the confirmation block (hidden until done)   (swap mode)
   On submit the submit button beam-works (shared window.TPWLoading — the
   same wash + draw-on tick as the add-to-cart button), the form posts via
   fetch (NO page reload), then the wrapper flips to .tpw-is-done and CSS
   (tpw-loading.css) collapses the fields + reveals the confirmation.

   Modes:
     swap  — collapse the fields, reveal [data-tpw-formdone]   (newsletter section, contact)
     morph — the button itself becomes the confirmation ("Subscribed")  (footer field)

   • Native submit fallback on a NETWORK error (nothing reached the server,
     so no double-post). Invalid forms never reach here — the browser blocks
     the submit event on failed native validation (required / type=email).
   • No-JS: liquid renders .tpw-is-done on the wrapper when posted_successfully.
   • Optimistic success on any server response (matches the shipped popup):
     client-side validation gates the common errors; server rejections are rare.
   ===================================================================== */
(function () {
  "use strict";
  if (window.__tpwFormSwap) return;
  window.__tpwFormSwap = true;

  // choose the beam contrast from the button's own background luminance
  function onColor(btn) {
    try {
      var m = getComputedStyle(btn).backgroundColor.match(/\d+/g);
      if (m) {
        var l = 0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2];
        return l < 140 ? "dark" : "light";
      }
    } catch (e) {}
    return "dark";
  }

  // a button may carry its label in a dedicated child (e.g. theme .button__label);
  // target that so the swap doesn't duplicate text alongside the span.
  function labelOf(btn) {
    return (btn && btn.querySelector(".button__label")) || null;
  }

  function succeed(box, form, btn, mode) {
    if (btn && window.TPWLoading) {
      // morph: the button IS the confirmation -> "Subscribed ✓", no drawn tick (it
      // would overlap the label on a compact field). swap: the form collapses to its
      // own ringed-tick block, so the button's done state is hidden anyway.
      window.TPWLoading.done(btn, {
        label: mode === "morph" ? "Subscribed ✓" : "Sent",
        hold: 0,
        tick: mode !== "morph",
        labelEl: labelOf(btn) || undefined,
      });
    } else if (btn) {
      btn.removeAttribute("aria-busy");
    }
    box.classList.add("tpw-is-done");
    // lock the fields so the confirmed form can't be re-submitted
    try { [].forEach.call(form.elements, function (el) { el.disabled = true; }); } catch (e) {}
    // move focus to the confirmation for screen-reader + keyboard users (swap only)
    if (mode !== "morph") {
      var f = box.querySelector("[data-tpw-formdone] [tabindex],[data-tpw-formdone] h2,[data-tpw-formdone] h3,[data-tpw-formdone]");
      if (f) { try { f.focus(); } catch (e) {} }
    }
  }

  function bind(form) {
    var box = form.querySelector("[data-tpw-formswap]");
    if (!box || box.__tpwBound) return;
    box.__tpwBound = true;
    var mode = box.getAttribute("data-tpw-formswap") || "swap";
    var btn = form.querySelector('button[type="submit"],input[type="submit"]');

    form.addEventListener("submit", function (e) {
      if (!window.fetch || !window.FormData) return; // submit natively
      e.preventDefault();
      var action = form.getAttribute("action") || window.location.pathname;

      if (btn && window.TPWLoading) {
        window.TPWLoading.start(btn, {
          label: mode === "morph" ? "Subscribing" : "Sending",
          onColor: onColor(btn),
          labelEl: labelOf(btn) || undefined,
        });
      } else if (btn) {
        btn.setAttribute("aria-busy", "true");
      }

      fetch(action, {
        method: "POST",
        body: new FormData(form),
        headers: { "X-Requested-With": "XMLHttpRequest", Accept: "text/html" },
      })
        .then(function () { succeed(box, form, btn, mode); })
        .catch(function () {
          // network error: nothing posted -> safe to submit natively (no double-post)
          if (btn && window.TPWLoading) window.TPWLoading.reset(btn);
          form.submit();
        });
    });
  }

  function init() {
    [].forEach.call(document.querySelectorAll("form"), function (f) {
      if (f.querySelector("[data-tpw-formswap]")) bind(f);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
